import { Checkbox, FormControlLabel, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from 'react';
import NumberFormat from "react-number-format";
import useStyles from "../../Styles";

const GeneratorComponent = (props) => {

    const classes = useStyles(props);
    const [isEdit, setIsEdit] = useState(false);
    const [generator, setGenerator] = useState({
        id: undefined,
        accountId: undefined,
        generatorName: '',
        queueNumber: '',
        toZone: '',
        mfo: undefined,
        isCapacity: false,
        cirs: undefined,
        powerMeterId: undefined,
        marketsGatewayId: '',
        pnodeId: undefined,
        pnodeName: '',
        connectionVoltage: undefined,
        substationName: '',
        submitStationService: false,
        separateStationService: false,
        stationServicePowerMeterId: undefined
    });

    useEffect(() => {
        if (props.generator) {
            setGenerator({ ...props.generator });
        }
        setIsEdit(props.isEdit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.generator, props.isEdit])

    const handleTextValueChange = (e, fieldName) => {
        generator[fieldName] = e.target.value;
        setGenerator({ ...generator });
        if (props.onChange) {
            props.onChange(generator);
        }
    }

    const handleDecimalValueChange = (e, fieldName) => {
        generator[fieldName] = Number.parseFloat(e.value);
        setGenerator({ ...generator });
        if (props.onChange) {
            props.onChange(generator);
        }
    }

    const handleIsCapacityChange = () => {
        generator.isCapacity = !generator.isCapacity;
        setGenerator({ ...generator });
        if (props.onChange) {
            props.onChange(generator);
        }
    }

    const handleSubmitStationServiceChange = () => {
        generator.submitStationService = !generator.submitStationService;
        if (generator.separateStationService) {
            generator.separateStationService = false;
            generator.stationServicePowerMeterId = undefined;
        }
        setGenerator({ ...generator });
        if (props.onChange) {
            props.onChange(generator);
        }
    }

    const handleSeparateStationServiceChange = () => {
        generator.separateStationService = !generator.separateStationService;
        if (!generator.separateStationService) {
            generator.stationServicePowerMeterId = undefined;
        }
        setGenerator({ ...generator });
        if (props.onChange) {
            props.onChange(generator);
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="generatorName" id="generatorName" value={generator.generatorName} onChange={(e, fieldName) => handleTextValueChange(e, "generatorName")} label="Generator Name" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <TextField name="queueNumber" id="queueNumber" value={generator.queueNumber} onChange={(e, fieldName) => handleTextValueChange(e, "queueNumber")} label="Queue Number" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <TextField name="toZone" id="toZone" value={generator.toZone} onChange={(e, fieldName) => handleTextValueChange(e, "toZone")} label="TO Zone" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="pnodeId" id="pnodeId" value={generator.pnodeId} onChange={(e, fieldName) => handleTextValueChange(e, "pnodeId")} label="PNode Id" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <TextField name="pnodeName" id="pnodeName" value={generator.pnodeName} onChange={(e, fieldName) => handleTextValueChange(e, "pnodeName")} label="PNode Name" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <NumberFormat value={generator.connectionVoltage} customInput={TextField} decimalScale={1} type='text' onValueChange={(e, fieldName) => handleDecimalValueChange(e, 'connectionVoltage')} label="Connection Voltage" placeholder="kV" suffix=" kV" disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <TextField name="substationName" id="substationName" value={generator.substationName} onChange={(e, fieldName) => handleTextValueChange(e, "substationName")} label="Substation Name" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <TextField name="marketsGatewayId" id="marketsGatewayId" value={generator.marketsGatewayId} onChange={(e, fieldName) => handleTextValueChange(e, "marketsGatewayId")} label="Markets Gateway Id" fullWidth disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <NumberFormat value={generator.mfo} customInput={TextField} decimalScale={3} type='text' onValueChange={(e, fieldName) => handleDecimalValueChange(e, "mfo")} fixedDecimalScale={true} label="MFO" placeholder="MWs" suffix=" MWs" disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <FormControlLabel control={<Checkbox checked={generator.isCapacity} onChange={handleIsCapacityChange} />} label="Capacity Resource" disabled={!isEdit} />
            </Grid>
            {generator.isCapacity ? (
                <React.Fragment>
                    <Grid item xs={6} sm={2} />
                    <Grid item xs={6} sm={2}>
                        <NumberFormat value={generator.cirs} customInput={TextField} decimalScale={3} type='text' onValueChange={(e, fieldName) => handleDecimalValueChange(e, "cirs")} fixedDecimalScale={true} label="CIRs" placeholder="MWs" suffix=" MWs" disabled={!isEdit} />
                    </Grid>
                </React.Fragment>
            ) : (
                <Grid item xs={6} sm={5} />
            )}
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={1} />
            <Grid item xs={6} sm={2}>
                <NumberFormat value={generator.powerMeterId} customInput={TextField} decimalScale={0} type='text' onValueChange={(e, fieldName) => handleDecimalValueChange(e, "powerMeterId")} fixedDecimalScale={true} label="PowerMeter Id" disabled={!isEdit} />
            </Grid>
            <Grid item xs={6} sm={2} />
            <Grid item xs={6} sm={2}>
                <FormControlLabel control={<Checkbox checked={generator.submitStationService} onChange={handleSubmitStationServiceChange} />} label="Submit Station Service" disabled={!isEdit} />
            </Grid>
            {generator.submitStationService ? (
                <Grid item xs={6} sm={2}>
                    <FormControlLabel control={<Checkbox checked={generator.separateStationService} onChange={handleSeparateStationServiceChange} />} label="Separate Station Service" disabled={!isEdit} />
                </Grid>
            ) : (
                <Grid item xs={6} sm={2} />
            )
            }
            {generator.separateStationService ? (
                <Grid item xs={6} sm={2}>
                    <NumberFormat value={generator.stationServicePowerMeterId} customInput={TextField} decimalScale={0} type='text' onValueChange={(e, fieldName) => handleDecimalValueChange(e, "stationServicePowerMeterId")} fixedDecimalScale={true} label="SS Power Meter Id" disabled={!isEdit} />
                </Grid>
            ) : (
                <Grid item xs={6} sm={2} />
            )}
            <Grid item xs={6} sm={1} />
        </Grid>
    )
}

export default GeneratorComponent;